import { render, staticRenderFns } from "./EmployeeMatchCandidates.vue?vue&type=template&id=2caa4c83&scoped=true&"
import script from "./EmployeeMatchCandidates.vue?vue&type=script&lang=js&"
export * from "./EmployeeMatchCandidates.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeMatchCandidates.vue?vue&type=style&index=0&id=2caa4c83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caa4c83",
  null
  
)

export default component.exports